// Mock FCM utilities for local testing
// This simulates notification behavior without requiring HTTPS or Firebase

/**
 * Mock: Request notification permission
 * Always succeeds in dev mode (unless notifications are blocked)
 */
export const requestNotificationPermission = async (user) => {
  if (!user) {
    console.log('[MOCK] No user provided');
    return null;
  }

  // Check if notifications are available
  if (!('Notification' in window)) {
    console.log('[MOCK] Notifications not supported');
    return null;
  }

  // Respect actual browser permission in dev (for realistic testing)
  const currentPermission = Notification.permission;
  console.log('[MOCK] Browser permission:', currentPermission);
  
  if (currentPermission === 'denied') {
    console.log('[MOCK] ❌ Permission denied, cannot enable');
    return null;
  }

  console.log('[MOCK] ✅ Simulating notification permission grant');
  
  // If permission is 'default', simulate granting it
  if (currentPermission === 'default') {
    console.log('[MOCK] Would show permission dialog in production');
    console.log('[MOCK] Auto-granting for local testing');
  }
  
  // Return fake token (always succeeds in dev unless denied)
  const mockToken = `mock_token_${user.uid}_${Date.now()}`;
  console.log('[MOCK] ✅ Generated mock FCM token:', mockToken);
  
  return mockToken;
};

/**
 * Mock: Check if permission granted
 * Returns true in dev for testing
 */
export const hasNotificationPermission = () => {
  if (!('Notification' in window)) return false;
  
  // In dev, always return true so toggles work
  const permission = Notification.permission;
  console.log('[MOCK] Current permission:', permission);
  
  // Always return true in dev mode for easier testing
  return true;
};

/**
 * Mock: Listen for foreground messages
 * Just logs to console
 */
export const onForegroundMessage = (callback) => {
  console.log('[MOCK] Foreground message listener registered');
  
  // Simulate a test message after 5 seconds
  setTimeout(() => {
    console.log('[MOCK] 📬 Simulating foreground message');
    callback({
      notification: {
        title: 'Mock Notification',
        body: 'This is a test notification (dev mode)'
      },
      data: {
        matchId: 'test-match',
        type: 'test'
      }
    });
  }, 5000);
  
  return () => {
    console.log('[MOCK] Foreground message listener unsubscribed');
  };
};

/**
 * Mock: Delete notification token
 */
export const deleteNotificationToken = async (user) => {
  if (!user) return;
  console.log('[MOCK] ✅ Deleted mock FCM tokens for user:', user.uid);
};

/**
 * Mock: Send test notification
 * Shows browser notification if permission granted
 */
export const sendTestNotification = () => {
  console.log('[MOCK] 📬 Sending test notification');
  
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification('Test Notification (Dev Mode)', {
      body: 'This is a local test notification!',
      icon: '/logo192.png',
      tag: 'test'
    });
  } else {
    console.log('[MOCK] Would show notification in production');
    alert('🔔 Test Notification\n\nThis would be a push notification in production!\n\n(In dev mode, you can grant browser permission to see real notifications)');
  }
};

